import { CommonPopupsView } from 'es6/views/popups/common-popups-view'
import { OldBrowserPopupView } from 'es6/views/popups/old-browser-popup-view'
import { UserView } from 'es6/views/user-view'
import $ from 'init/jquery'
import { BodyView } from 'es6/views/body-view'
import { MobileBodyView } from 'mobile/es6/common/views/mobile-body-view'
import { FaderView } from 'es6/views/fader/fader-view'
import { FooterView } from 'es6/views/footer/footer-view'
import { ToTopView } from 'es6/views/footer/to-top-view'
import { MainWindow } from 'es6/views/main-window-view'
import { OverlayView } from 'es6/views/overlay-view'
import { SearchBarView } from 'es6/views/search/search-bar-view'
import { cart } from 'init/cart'
import { settlement } from 'init/settlement'
import { user } from 'init/user'
import { pushToRegistry } from 'init/registry'
import bowser from 'bowser'
import { getCurrentOsVersions, getOperaMiniOrMobileOptions } from 'helpers/browser-detect-helper'
import { ReduxDispatchesView } from 'es6/views/redux-dispatches-view'
import { NewsComments } from 'es6/collections/news-comments'
import { NewsCommentsView } from './views/news-comments-view'
import { NewsCommentsFormView } from './views/news-comments-form-view'
import { connectCartToOko, okoPush } from 'helpers/oko-helpers'
import { currentCurrency } from 'init/current-currency'
import { redirectWithNewParams } from 'helpers/redirect-helper'
import {
  createExecuteChannel,
  subscribeToCommands,
  createCommandChannel,
} from 'helpers/cqc-helper'
import {
  CQC_COMMAND_TYPES,
  CQC_ES6_CONTEXT,
  VK_TARGETING_EVENT_TYPES,
} from 'es6/constants'
import { pushVkEvent } from 'helpers/vk-targeting-helper'
import { isMobile } from 'init/is-mobile'

createExecuteChannel([
  CQC_COMMAND_TYPES.settlementUpdate,
  CQC_COMMAND_TYPES.currencyUpdate,
], CQC_ES6_CONTEXT)
subscribeToCommands([CQC_COMMAND_TYPES.settlementUpdate])

const currencyUpdateCallback = data => {
  const newCurrencyName = data.currency.name
  if (newCurrencyName !== currentCurrency.name) {
    redirectWithNewParams({ currency: newCurrencyName })
  }
}
subscribeToCommands(CQC_COMMAND_TYPES.currencyUpdate, currencyUpdateCallback)

let playbackInterval
const layout = $('.layout'),
  jsView = layout.data('jsview') || $('.main-content').data('jsview'),
  mainWindow = new MainWindow(),
  fader = new FaderView(),
  searchBarOptions = {
    el: $('#search-form').length ? $('#search-form') : $('#w0'),
    user: user,
  },
  bodyOptions = {
    jsView: jsView,
    settlement: settlement,
    user: user,
    faderView: fader,
    cart: cart,
    autoRewritePageLinks: false,
  },
  bodyView = isMobile ? new MobileBodyView(bodyOptions) : new BodyView(bodyOptions),
  comments = new NewsComments()

const newsId = $('.news-comments').data('news-id')
comments.news_id = newsId
pushToRegistry(
  new ReduxDispatchesView({
    jsView,
    settlement,
  }),
  new UserView({
    settlement: settlement,
    user: user,
  }),
  new CommonPopupsView(),
  new OverlayView(),
  new FooterView({
    cart: cart,
    settlement: settlement,
    user: user,
  }),
  new ToTopView({
    mainWindow: mainWindow,
  }),
  new SearchBarView(searchBarOptions),
  bodyView,
  new NewsCommentsView({
    itemId: newsId,
    collection: comments,
    user: user,
    FormView: NewsCommentsFormView,
  }),
  new OldBrowserPopupView({
    versions: getCurrentOsVersions(bowser),
    bowser: bowser,
    operaMiniOrMobileOptions: getOperaMiniOrMobileOptions(bowser, navigator),
    isPageSpeedTest: navigator.userAgent.includes('Google Page Speed'),
  }),
)

const $videos = $('video')
if ($videos.length) {
  $videos.each((index, elem) => {
    $(elem).on('play pause ended', e => {
      const { type, target } = e
      okoPush({
        n: 'video',
        action: type,
      })
      if (type === 'play') {
        playbackInterval = setInterval(() => {
          okoPush({
            n: 'video',
            time: target.currentTime,
          })
        }, 10000)
      } else {
        clearInterval(playbackInterval)
      }
    })
  })
}

const { cartUpdate, showForm, showAuthForm,
  showRegistrationForm } = CQC_COMMAND_TYPES
createCommandChannel([cartUpdate, showForm, showAuthForm, showRegistrationForm], CQC_ES6_CONTEXT, true)

connectCartToOko(cart)
pushVkEvent(VK_TARGETING_EVENT_TYPES.other, {})
